import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import sitemap from '../Sitemap';

// SYTLES
const Nav = styled.nav`
`;

const StyledNavLink = styled(NavLink)`
  margin: 0 15px;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: bold;
  transition: all 0.2s;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    text-decoration: none;
    color: ${ props => props.theme.color.secondary };
  }

  &.active {
    border-bottom: 2px solid ${props => props.theme.color.text.body};
  }
`;

// COMPONENT
const Navigation = props => {

  return (
    <Nav {...props}>
      { sitemap.map(page => (
        <StyledNavLink
          to={ page.link }
          key={ page.alias }
        >

          { page.label }

        </StyledNavLink>
      )) }
    </Nav>
  );
};

export default translate(Navigation);